/**
 * Size of SVG for both qualifier and icon
 */
export const ICON_SIZES = {
  s: { width: "16", height: "16" },
  m: { width: "18", height: "18" },
}

/**
 * Size values
 */
export const SIZES = {
  s: "s",
  m: "m",
}

/**
 * Default size value
 */
export const DEFAULT_SIZE = "m"
